<script >
import { Popup } from '@futuweb/future-ui';
import '@futuweb/future-ui/es/popup/style/index';
import StockForm from './stock-form.vue';

// 说明：该组件仅负责移动端 Popup 展示，表单内容复用 stock-form.vue（不包含 Popup 逻辑）
const __sfc_main = {};
__sfc_main.props = {
  // 当前操作的场次（用于展示当前价格等）
  session: {
    type: Object,
    default: null
  },
  // 当前用户记录（用于回填）
  record: {
    type: Object,
    default: null
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const emit = __ctx.emit;
  const props = __props;
  return {
    emit,
    props
  };
};
__sfc_main.components = Object.assign({
  Popup,
  StockForm
}, __sfc_main.components);
export default __sfc_main;
</script>

<template>
    <Popup :visible="true" position="bottom" class="stock-form-popup" @close="emit('close')">
        <StockForm
            :session="props.session"
            :record="props.record"
            @submit="(data) => emit('submit', data)"
        />
    </Popup>
</template>

<style lang="less">
.stock-form-popup {
    .ui-popup {
        height: auto;
        border-top-right-radius: 0.16rem;
        border-top-left-radius: 0.16rem;
    }
}
</style>


